// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptId: __t.u64().primaryKey().name("receipt_id"),
  campaignId: __t.u64().name("campaign_id"),
  identity: __t.identity(),
  side: __t.u8(),
  kind: __t.string(),
  ref: __t.string(),
  points: __t.u32(),
  paidSov: __t.i64().name("paid_sov"),
  at: __t.timestamp(),
});
